import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '20px' }}>
          {/* 公司信息 */}
          <div style={{ flex: '1', minWidth: '200px' }}>
            <h3 style={{ fontSize: '18px', marginBottom: '15px' }}>AI-EDGE</h3>
            <p style={{ color: '#98a6ad', lineHeight: '1.6', fontSize: '14px' }}>
              AI-EDGE是一家专注于AI驱动的量化交易和股票分析的科技公司，致力于为投资者提供高质量的市场洞察和交易策略。
            </p>
            <div style={{ marginTop: '20px' }}>
              <Link to="#" style={{ marginRight: '15px', color: '#98a6ad' }}>
                <i className="fab fa-facebook"></i>
              </Link>
              <Link to="#" style={{ marginRight: '15px', color: '#98a6ad' }}>
                <i className="fab fa-twitter"></i>
              </Link>
              <Link to="#" style={{ marginRight: '15px', color: '#98a6ad' }}>
                <i className="fab fa-linkedin"></i>
              </Link>
              <Link to="#" style={{ color: '#98a6ad' }}>
                <i className="fab fa-github"></i>
              </Link>
            </div>
          </div>

          {/* 快速链接 */}
          <div style={{ flex: '1', minWidth: '180px' }}>
            <h3 style={{ fontSize: '16px', marginBottom: '15px' }}>快速链接</h3>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li style={{ marginBottom: '8px' }}>
                <Link to="/" style={{ color: '#98a6ad', textDecoration: 'none', fontSize: '14px' }}>首页</Link>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Link to="/analysis" style={{ color: '#98a6ad', textDecoration: 'none', fontSize: '14px' }}>诊股</Link>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Link to="/news" style={{ color: '#98a6ad', textDecoration: 'none', fontSize: '14px' }}>新闻</Link>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Link to="/forum" style={{ color: '#98a6ad', textDecoration: 'none', fontSize: '14px' }}>论坛</Link>
              </li>
            </ul>
          </div>

          {/* 分析工具 */}
          <div style={{ flex: '1', minWidth: '180px' }}>
            <h3 style={{ fontSize: '16px', marginBottom: '15px' }}>分析工具</h3>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li style={{ marginBottom: '8px' }}>
                <Link to="/analysis" style={{ color: '#98a6ad', textDecoration: 'none', fontSize: '14px' }}>技术分析</Link>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Link to="/analysis" style={{ color: '#98a6ad', textDecoration: 'none', fontSize: '14px' }}>基本面分析</Link>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Link to="/analysis" style={{ color: '#98a6ad', textDecoration: 'none', fontSize: '14px' }}>市场行情</Link>
              </li>
              <li style={{ marginBottom: '8px' }}>
                <Link to="/analysis" style={{ color: '#98a6ad', textDecoration: 'none', fontSize: '14px' }}>AI分析</Link>
              </li>
            </ul>
          </div>

          {/* 联系我们 */}
          <div style={{ flex: '1', minWidth: '180px' }}>
            <h3 style={{ fontSize: '16px', marginBottom: '15px' }}>联系我们</h3>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li style={{ marginBottom: '10px', color: '#98a6ad', fontSize: '14px' }}>
                <i className="fas fa-map-marker-alt" style={{ marginRight: '10px' }}></i>
                北京市朝阳区科技园A座10层
              </li>
              <li style={{ marginBottom: '10px', color: '#98a6ad', fontSize: '14px' }}>
                <i className="fas fa-phone-alt" style={{ marginRight: '10px' }}></i>
                +86 10 8888 7777
              </li>
              <li style={{ marginBottom: '10px', color: '#98a6ad', fontSize: '14px' }}>
                <i className="fas fa-envelope" style={{ marginRight: '10px' }}></i>
                contact@aiedge.com
              </li>
            </ul>
          </div>
        </div>

        {/* 底部版权信息 */}
        <div style={{ 
          borderTop: '1px solid rgba(152, 166, 173, 0.2)', 
          marginTop: '30px', 
          paddingTop: '20px', 
          textAlign: 'center' 
        }}>
          <p style={{ fontSize: '14px', color: '#98a6ad' }}>
            © {currentYear} AI-EDGE. 保留所有权利
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
